import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import type { FormState } from 'ngrx-forms';
import { NgrxFormsModule } from 'ngrx-forms';
import { TrackValueChangeDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  ValidationClassesDirective,
  HasValueDirective,
} from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: [
    './checkbox.component.ed.scss',
    './checkbox.component.essent.scss',
  ],
  standalone: true,
  imports: [
    NgrxFormsModule,
    AutomationIdDirective,
    ValidationClassesDirective,
    HasValueDirective,
    TrackValueChangeDirective,
    AutomationIdDirective,
    CommonUiUtilityComponentsModule,
  ],
})
export class CheckboxComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formsControl?: FormState<string> | FormState<boolean>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label = '';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() stepName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fieldName?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tooltip?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hashValue?: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() sendValue? = true;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() step?: number;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showValidation = true;
}
